// File: components/FAQChatWidget.js
import React, { useState } from 'react';
import { Card, ListGroup, Button } from 'react-bootstrap';

const faqs = [
  {
    question: 'How can I change my profile information?',
    answer: 'Go to the Profile tab in the sidebar, click Edit, make your changes, and click Save.',
  },
  {
    question: 'How do I assign a job to an electrician?',
    answer: 'Go to Jobs > New Job, fill out the job details, and assign it to an electrician from the dropdown.',
  },
  {
    question: 'How do I generate an invoice?',
    answer: 'Navigate to Invoices, click Create Invoice, choose the job, and fill in the necessary billing details.',
  },
  {
    question: 'Where can I manage staff?',
    answer: 'Click on the Staff tab in the sidebar. From there, you can add, edit, or remove staff members.',
  },
];

export default function FAQChatWidget() {
  const [open, setOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);

  const toggleChat = () => {
    setSelectedQuestion(null);
    setOpen((prev) => !prev);
  };

  return (
    <>
      {/* Floating Chat Icon */}
      {/* <div
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          zIndex: 9999,
        }}
      >
        {open && (
          <Card style={{ width: '320px', height: '400px', marginBottom: '10px', boxShadow: '0 0 12px rgba(0,0,0,0.15)' }}>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <strong>FAQ Chat</strong>
              <Button variant="light" size="sm" onClick={toggleChat}>✖</Button>
            </Card.Header>
            <Card.Body style={{ overflowY: 'auto' }}>
              {!selectedQuestion ? (
                <ListGroup>
                  {faqs.map((faq, index) => (
                    <ListGroup.Item
                      action
                      key={index}
                      onClick={() => setSelectedQuestion(faq)}
                    >
                      {faq.question}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              ) : (
                <div>
                  <div className="mb-3">
                    <strong>Q:</strong> {selectedQuestion.question}<br />
                    <strong>A:</strong> {selectedQuestion.answer}
                  </div>
                  <Button variant="secondary" size="sm" onClick={() => setSelectedQuestion(null)}>⬅ Back</Button>
                </div>
              )}
            </Card.Body>
          </Card>
        )}

        <Button
          variant="primary"
          className="rounded-circle"
          style={{ width: '60px', height: '60px' , position: 'absolute',right: 0 , bottom: 0, zIndex:-1}}
          onClick={toggleChat}
        >
          💬
        </Button>
      </div> */}
    </>
  );
}